/* global axios */
import ApiClient from './ApiClient';

class AccountScheduledMessagesAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  getAll({ status, inboxId, authorId, limit } = {}) {
    const params = {};
    if (status) params.status = status;
    if (inboxId) params.inbox_id = inboxId;
    if (authorId) params.author_id = authorId;
    if (limit) params.limit = limit;
    return axios.get(this.url, { params });
  }

  get(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new AccountScheduledMessagesAPI();
